<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="0" @submit.native.prevent inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model.trim="keyword" :placeholder="placeholder" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="$emit('on-add')">新增项目组</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectGroupManagerFilter',
  props: {
    placeholder: {
      type: String
    }
  },
  methods: {
    search() {
      this.$emit('on-refresh', { keyword: this.keyword })
    }
  },
  data() {
    return {
      keyword: ''
    }
  }
}
</script>
